import axios from 'axios';
import { getEnv } from 'config/enviroment';

const env = getEnv();

export default axios.create({
  baseURL: env && env.API_URL,
  headers: { 'Content-Type': 'multipart/form-data' },
});
